import { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Alert } from '@mui/material';
import { useApi } from '../../../hooks/useApi';
import type { Enrolment } from '../../../types/alertEnrolment';

export default function DeleteEnrolmentDialog({ enrolment, onClose, onDeleted }: {
  enrolment: Enrolment | null; onClose: () => void; onDeleted: () => void;
}) {
  const { del, loading } = useApi();
  const [error, setError] = useState<string | null>(null);

  const confirm = async () => {
    if (!enrolment) return;
    setError(null);
    try { await del(`/api/alert-enrolments/${enrolment.id}`, { slowApi: true }); onDeleted(); onClose(); }
    catch (e: any) { setError(e.message ?? 'Failed to delete'); }
  };

  return (
    <Dialog open={Boolean(enrolment)} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Delete enrolment?</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Typography variant="body2">
          You're about to permanently delete the enrolment for <strong>{enrolment?.ppAccountName}</strong>, including its combinations and history. This can't be undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button color="error" variant="contained" onClick={confirm} disabled={loading}>Delete enrolment</Button>
      </DialogActions>
    </Dialog>
  );
}
